// src/Screen/Receiveable.jsx
import React, { useEffect, useState } from "react";
import Loading from "../Modals/Loading";
import { useNavigate } from "react-router-dom";
import ReceivableService from "../Services/receivableService";
import moment from "moment/moment";
import Head from "../Components/Head";
import { FaCheck } from "react-icons/fa";
import { RiTimeLine } from "react-icons/ri";
import ModalReceiveable from "../Components/ModalRecieveable";

const Receiveable = () => {
  const [receivables, setReceivables] = useState([]);
  const [loading, setLoading] = useState(false);

  // filters/search
  const [pendingStartDate, setPendingStartDate] = useState("");
  const [pendingEndDate, setPendingEndDate] = useState("");
  const [clearedStartDate, setClearedStartDate] = useState("");
  const [clearedEndDate, setClearedEndDate] = useState("");
  const [searchPending, setSearchPending] = useState("");
  const [searchCleared, setSearchCleared] = useState("");

  // ⬇️ removed openChequeNumbers and toggleCheques for PENDING table
  const [openClearedChequeNumbers, setOpenClearedChequeNumbers] = useState([]); // keep for CLEARED table

  // modal state
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const navigate = useNavigate();

  const getReceivables = async () => {
    try {
      setLoading(true);
      const response = await ReceivableService.fetchAll();
      setReceivables(response.receivables || []);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getReceivables();
  }, []);

  // const clearCheck = async (chequeNumber, customerId, amount) => {
  //   try {
  //     await ReceivableService.clear(chequeNumber);
  //     await getReceivables();
  //     navigate("/incomes/add", { state: { customerId, amount } });
  //   } catch (error) {
  //     console.error("Error clearing receivable:", error);
  //   }
  // };

const clearCheck = async (chequeNumber) => {
  try {
    const group = receivables.filter((r) => r.number === chequeNumber);

    if (group.length === 0) {
      console.error("No receivables found for cheque:", chequeNumber);
      return;
    }

    const customerId = group[0].customer;

    const orderIds = group
      .map((item) => item.order_id)
      .filter((id) => id !== null)
      .map((id) => id.toString());

    const totalAmount = group.reduce(
      (sum, item) => sum + Number(item.amount),
      0
    );

    await ReceivableService.clear(chequeNumber);

    await getReceivables();
    
    navigate("/incomes/add", {
      state: {
        customerId,
        orderIds,
        amount: totalAmount,
      },
    });
  } catch (error) {
    console.error("Error clearing receivable:", error);
  }
};

  
  // ---- modal handlers (pass whole group)
  const openConfirm = (row, chequeNumber, group = []) => {
    setSelectedRow({ ...row, chequeNumber, group });
    setConfirmOpen(true);
  };
  const closeConfirm = () => {
    setConfirmOpen(false);
    setSelectedRow(null);
  };
  const handleConfirmClear = async () => {
    if (!selectedRow) return;
    await clearCheck(
      selectedRow.chequeNumber,
      //selectedRow.customer ?? selectedRow.customer_name,
      //selectedRow.amount
    );
    closeConfirm();
  };

  const totalClearedAmount = receivables.reduce(
    (sum, curr) =>
      curr.status === "CLEARED" ? sum + parseFloat(curr.amount || 0) : sum,
    0
  );

  const totalPendingAmount = receivables.reduce(
    (sum, curr) =>
      curr.status !== "CLEARED" ? sum + parseFloat(curr.amount || 0) : sum,
    0
  );

  const filterByDate = (data, start, end) => {
    if (!start && !end) return data;

    return data.filter((item) => {
      const payableDate = moment(item.payable);
      const startDate = start ? moment(start) : null;
      const endDate = end ? moment(end) : null;

      if (startDate && endDate)
        return payableDate.isBetween(startDate, endDate, undefined, "[]");
      if (startDate) return payableDate.isSameOrAfter(startDate);
      if (endDate) return payableDate.isSameOrBefore(endDate);
      return true;
    });
  };

  const groupByCheque = (data) =>
    data.reduce((acc, item) => {
      if (!acc[item.number]) acc[item.number] = [];
      acc[item.number].push(item);
      return acc;
    }, {});

  // pending / cleared datasets
  const pendingData = filterByDate(
    receivables.filter((r) => r.status !== "CLEARED"),
    pendingStartDate,
    pendingEndDate
  );
  const clearedData = filterByDate(
    receivables.filter((r) => r.status === "CLEARED"),
    clearedStartDate,
    clearedEndDate
  );

  const filteredPendingData = pendingData.filter((item) =>
    item?.customer_name?.toLowerCase().includes(searchPending.toLowerCase())
  );
  const filteredClearedData = clearedData.filter((item) =>
    item?.customer_name?.toLowerCase().includes(searchCleared.toLowerCase())
  );

  // expand/collapse for CLEARED table (kept)
  const toggleClearedCheques = (chequeNumber) => {
    setOpenClearedChequeNumbers((prev) =>
      prev.includes(chequeNumber)
        ? prev.filter((n) => n !== chequeNumber)
        : [...prev, chequeNumber]
    );
  };

  const groupedCleared = groupByCheque(filteredClearedData);

  return (
    <div className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      {loading ? (
        <Loading />
      ) : (
        <>
          <Head
            heading={"PDC Receivable"}
            button_text={"Add Receivable"}
            navigation={() => navigate("/receiveable/add")}
          />

          {/* -------- Pending Controls */}
          <div className="flex items-center gap-6 mb-4 mt-4">
            <div className="flex flex-col">
              <label className="primary-label">Search</label>
              <input
                type="text"
                placeholder="Search Here..."
                value={searchPending}
                onChange={(e) => setSearchPending(e.target.value)}
                className="primary-input !w-80"
              />
            </div>
            <div className="flex flex-col">
              <label className="primary-label">Start Date:</label>
              <input
                type="date"
                value={pendingStartDate}
                onChange={(e) => setPendingStartDate(e.target.value)}
                className="primary-input"
              />
            </div>
            <div className="flex flex-col">
              <label className="primary-label">End Date:</label>
              <input
                type="date"
                value={pendingEndDate}
                onChange={(e) => setPendingEndDate(e.target.value)}
                className="primary-input"
              />
            </div>
          </div>

          {/* -------- Pending Table (NO DROPDOWN) */}
          {filteredPendingData.length > 0 ? (
            <div className="table-div">
              <table>
                <caption className="mb-10">
                  <div className="flex items-center justify-center gap-4">
                    <RiTimeLine className="text-secondary h-10 w-10" />
                    <span className="font-bold text-2xl text-secondary">
                      Pending
                    </span>
                  </div>
                </caption>
                <thead>
                  <tr className="border-y-2 text-left w-full text-black text-[10px]">
                    <th className="rounded-tl-lg w-[1%] py-4 pl-4">Sr No.</th>
                    <th className="w-[3%] py-4 pl-4">Received Date.</th>
                    <th className="w-[3%] py-4 pl-4">Presentable Date</th>
                    <th className="w-[6%] py-4 pl-4">Customer Name</th>
                    <th className="w-[3%] py-4 pl-4">Cheque No</th>
                    <th className="w-[3%] py-4 pl-4">Order No</th>
                    <th className="w-[3%] py-4 pl-4">Order Amount</th>
                    <th className="w-[4%] py-4 pl-4">Bank Name</th>
                    <th className="w-[2%] py-4 pl-4">Amount</th>
                    <th className="w-[2%] py-4 text-center">Status</th>
                    <th className="w-[3%] py-4 text-center">Action</th>
                    <th className="rounded-tr-lg w-[2%] py-4 text-center"></th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(groupByCheque(filteredPendingData)).map(
                    ([chequeNumber, items], idx) => (
                      <React.Fragment key={chequeNumber}>
                        {/* Head row */}
                        <tr className="bg-accent border-b border-gray-100 text-left">
                          <td className="w-[1%] text-[10px] font-bold pl-4">
                            {idx + 1}
                          </td>
                          <td className="py-4 w-[3%] pl-4">
                            {moment(items[0].receiving).format("ll")}
                          </td>
                          <td className="py-4 w-[3%] pl-4">
                            {moment(items[0].payable).format("ll")}
                          </td>
                          <td className="w-[6%] text-[10px] font-bold pl-4">
                            {items[0].customer_name}
                          </td>
                          <td className="py-4 w-[3%] pl-4">
                            {items[0].number}
                          </td>
                          <td className="py-4 w-[4%] pl-4">
                            {items[0].order_id || "N/A"}
                          </td>
                          <td className="py-4 w-[4%] pl-4">
                            {items[0].vat_amount || "Not Available"}
                          </td>
                          <td className="py-4 w-[4%] pl-4">{items[0].bank}</td>

                          {/* Always show total for the group */}
                          <td className="py-4 w-[2%] font-bold pl-4">
                            {items
                              .reduce(
                                (sum, c) => sum + parseFloat(c.amount || 0),
                                0
                              )
                              .toFixed(2)}
                          </td>

                          <td className="py-4 w-[2%] text-center">
                            <p
                              className={`${
                                items[0].status === "CLEARED"
                                  ? "bg-green-500 text-green-500"
                                  : "bg-red-500 text-red-500"
                              } px-2 py-1 inline-block text-[10px] rounded-md uppercase bg-opacity-20 font-semibold`}
                            >
                              {items[0].status}
                            </p>
                          </td>

                          {/* Action buttons */}
                          <td className="py-4 w-[3%] text-center">
                            <button
                              onClick={() =>
                                openConfirm(items[0], chequeNumber, items)
                              } // modal only
                              disabled={items[0].status === "CLEARED"}
                              className={`button-primary !text-[8px] !w-[100px] !py-1 ${
                                items[0].status === "CLEARED"
                                  ? "opacity-50 cursor-not-allowed"
                                  : ""
                              }`}
                            >
                              Clear Check
                            </button>
                          </td>

                          {/* View Cheques (modal only, no dropdown) */}
                          <td className="text-center">
                            <button
                              onClick={() =>
                                openConfirm(items[0], chequeNumber, items)
                              } // modal only
                              className="bg-[#FCDADA] text-red-500 font-semibold !text-[10px] rounded !w-[100px] !py-1"
                            >
                              View Cheques
                            </button>
                          </td>
                        </tr>

                        {/* ⬇️ Removed expanded rows for PENDING */}
                      </React.Fragment>
                    )
                  )}
                </tbody>
                <tfoot>
                  <tr className="bg-gray-100 text-left">
                    <td></td>
                    <td className="font-bold pl-4 py-4" colSpan="7">
                      Total
                    </td>
                    <td className="font-bold pl-4 py-4 text-teal-600">
                      {filteredPendingData
                        .reduce(
                          (sum, curr) => sum + parseFloat(curr.amount || 0),
                          0
                        )
                        .toFixed(2)}
                    </td>
                    <td colSpan="3"></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          ) : (
            <div className="mt-20">
              <h1 className="font-bold text-2xl text-gray-700 text-center">
                No Data Found
              </h1>
            </div>
          )}

          {/* -------- Cleared Controls */}
          <div className="flex items-center gap-4 mt-20 mb-4">
            <div className="flex flex-col">
              <label className="primary-label">Search</label>
              <input
                type="text"
                placeholder="Search Here..."
                value={searchCleared}
                onChange={(e) => setSearchCleared(e.target.value)}
                className="primary-input !w-80"
              />
            </div>
            <div className="flex flex-col">
              <label className="primary-label">Start Date:</label>
              <input
                type="date"
                value={clearedStartDate}
                onChange={(e) => setClearedStartDate(e.target.value)}
                className="primary-input"
              />
            </div>
            <div className="flex flex-col">
              <label className="primary-label">End Date:</label>
              <input
                type="date"
                value={clearedEndDate}
                onChange={(e) => setClearedEndDate(e.target.value)}
                className="primary-input"
              />
            </div>
          </div>

          {/* -------- Cleared Table (unchanged dropdown behavior) */}
          {Object.keys(groupedCleared).length > 0 ? (
            <div className="table-div !mt-4">
              <table>
                <caption className="mb-10">
                  <div className="flex items-center justify-center gap-4">
                    <FaCheck className="text-green-600 h-10 w-10" />
                    <span className="font-bold text-2xl text-green-600">
                      Cleared
                    </span>
                  </div>
                </caption>
                <thead>
                  <tr className="border-y-2 text-left w-full text-black text-[10px]">
                    <th className="rounded-tl-lg w-[1%] py-4 pl-4">Sr No.</th>
                    <th className="w-[3%] py-4 pl-4">Received Date.</th>
                    <th className="w-[3%] py-4 pl-4">Presentable Date</th>
                    <th className="w-[6%] py-4 pl-4">Customer Name</th>
                    <th className="w-[3%] py-4 pl-4">Cheque No</th>
                    <th className="w-[3%] py-4 pl-4">Order No</th>
                    <th className="w-[3%] py-4 pl-4">Order Amount</th>
                    <th className="w-[4%] py-4 pl-4">Bank Name</th>
                    <th className="w-[2%] py-4 pl-4">Amount</th>
                    <th className="w-[2%] py-4 text-center">Status</th>
                    <th className=" w-[3%] py-4 text-center">Action</th>
                    <th className="rounded-tr-lg w-[2%] py-4 text-center"></th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(groupByCheque(filteredClearedData)).map(
                    ([chequeNumber, items], idx) => (
                      <React.Fragment key={chequeNumber}>
                        {/* Head row */}
                        <tr className="bg-accent border-b border-gray-100 text-left">
                          <td className="w-[1%] text-[10px] font-bold pl-4">
                            {idx + 1}
                          </td>
                          <td className="py-4 w-[3%] pl-4">
                            {moment(items[0].receiving).format("ll")}
                          </td>
                          <td className="py-4 w-[3%] pl-4">
                            {moment(items[0].payable).format("ll")}
                          </td>
                          <td className="w-[6%] text-[10px] font-bold pl-4">
                            {items[0].customer_name}
                          </td>
                          <td className="py-4 w-[3%] pl-4">
                            {items[0].number}
                          </td>
                          <td className="py-4 w-[4%] pl-4">
                            {items[0].order_id || "N/A"}
                          </td>
                          <td className="py-4 w-[4%] pl-4">
                            {items[0].vat_amount || "Not Available"}
                          </td>
                          <td className="py-4 w-[4%] pl-4">{items[0].bank}</td>
                          <td className="py-4 w-[2%] font-bold pl-4">
                            {openClearedChequeNumbers.includes(chequeNumber)
                              ? items[0].amount
                              : items
                                  .reduce(
                                    (sum, c) => sum + parseFloat(c.amount || 0),
                                    0
                                  )
                                  .toFixed(2)}
                          </td>
                          <td className="py-4 w-[2%] text-center">
                            <p
                              className={`${
                                items[0].status === "CLEARED"
                                  ? "bg-green-500 text-green-500"
                                  : "bg-red-500 text-red-500"
                              } px-2 py-1 inline-block text-[10px] rounded-md uppercase bg-opacity-20 font-semibold`}
                            >
                              {items[0].status}
                            </p>
                          </td>

                          {/* View in modal with full group */}
                          <td className="py-4 w-[3%] text-center">
                            <button
                              onClick={() =>
                                openConfirm(items[0], chequeNumber, items)
                              }
                              className="button-primary !text-[8px] !w-[100px] !py-1"
                            >
                              View
                            </button>
                          </td>

                          <td>
                            <button
                              onClick={() => {
                                toggleClearedCheques(chequeNumber);
                                openConfirm(items[0], chequeNumber, items); // also open modal
                              }}
                              className="bg-green-500 text-green-500 bg-opacity-20 font-semibold !text-[10px] rounded !w-[100px] !py-1"
                            >
                              {openClearedChequeNumbers.includes(chequeNumber)
                                ? "Hide Cheques ▲"
                                : "Show Cheques ▼"}
                            </button>
                          </td>
                        </tr>

                        {/* Expanded rows for CLEARED (kept) */}
                        {openClearedChequeNumbers.includes(chequeNumber) &&
                          items.slice(1).map((item, extraIdx) => (
                            <tr
                              key={`${chequeNumber}-${extraIdx}`}
                              className="bg-gray-50 border-b border-gray-100 text-left"
                            >
                              <td></td>
                              <td className="py-4 w-[3%] pl-4">
                                {moment(item.receiving).format("ll")}
                              </td>
                              <td className="py-4 w-[3%] pl-4">
                                {moment(item.payable).format("ll")}
                              </td>
                              <td className="w-[6%] text-[10px] font-bold pl-4">
                                {item.customer_name}
                              </td>
                              <td className="py-4 w-[3%] pl-4">
                                {item.number}
                              </td>
                              <td className="py-4 w-[4%] pl-4">
                                {item.order_id || "N/A"}
                              </td>
                              <td className="py-4 w-[4%] pl-4">
                                {item.vat_amount || "Not Available"}
                              </td>
                              <td className="py-4 w-[4%] pl-4">{item.bank}</td>
                              <td className="py-4 w-[2%] font-bold pl-4">
                                {item.amount}
                              </td>
                              <td className="py-4 w-[2%] text-center">
                                <p
                                  className={`${
                                    item.status === "CLEARED"
                                      ? "bg-green-500 text-green-500"
                                      : "bg-red-500 text-red-500"
                                  } px-2 py-1 inline-block text-[10px] rounded-md uppercase bg-opacity-20 font-semibold`}
                                >
                                  {item.status}
                                </p>
                              </td>
                              <td className="py-4 w-[3%] text-center">
                                <button
                                  onClick={() =>
                                    openConfirm(item, chequeNumber, items)
                                  }
                                  className="button-primary !text-[8px] !w-[100px] !py-1"
                                >
                                  View
                                </button>
                              </td>
                              <td colSpan="3"></td>
                            </tr>
                          ))}
                      </React.Fragment>
                    )
                  )}
                </tbody>
                <tfoot>
                  <tr className="bg-gray-100 text-left">
                    <td></td>
                    <td className="font-bold pl-4 py-4" colSpan="7">
                      Total
                    </td>
                    <td className="font-bold pl-4 py-4 text-teal-600">
                      {totalClearedAmount.toFixed(2)}
                    </td>
                    <td colSpan="3"></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          ) : (
            <div className="mt-20">
              <h1 className="font-bold text-2xl text-gray-700 text-center">
                No Data Found
              </h1>
            </div>
          )}

          {/* ---- Modal mounted once */}
          <ModalReceiveable
            open={confirmOpen}
            onClose={closeConfirm}
            selectedRow={selectedRow}
            onConfirm={handleConfirmClear}
          />
        </>
      )}
    </div>
  );
};

export default Receiveable;

